// src/i18n/es/fit.ts
// «Product C» (w7.u5, D16/D25): la herramienta interna de ajuste de la
// solución, cortada por las cuatro dimensiones de la versión 2.0 (versión
// de la aplicación, configuración, idioma; los intentos por método están
// dentro de las propias métricas, no son un quinto corte). Uso exclusivo
// del equipo de producto de Roommatik — nunca del hotel (CF S6 «Hide:
// product C»). Las etiquetas de cada métrica llegan verbatim de la API.
export const fit = {
  name: 'Ajuste de producto |||| Ajuste de producto',
  subtitle: 'Herramienta interna: métricas de paso cortadas por versión y configuración',

  cuts: {
    appVersion: 'Versión de la aplicación',
    flowConfigRef: 'Referencia de configuración',
    language: 'Idioma',
  },

  compare: {
    toggle: 'Comparar antes/después de un despliegue',
    before: 'Antes',
    after: 'Después',
  },

  list: {
    title: 'Indicadores',
  },

  help: {
    title: 'Ajuste de producto',
    description:
      'La herramienta de ajuste de producto (product C): las mismas métricas de paso de Operación, cortadas por versión de la aplicación, configuración e idioma, con una vista antes/después por despliegue. Uso interno del equipo de producto de Roommatik, nunca del hotel.',
    features: {
      cuts: 'Los tres cortes son de texto libre: no existe todavía un catálogo de versiones o configuraciones conocidas para una propiedad.',
      compare: 'Active la comparación para ver dos periodos y cortes independientes uno junto al otro; no es una resta calculada, son dos llamadas separadas a la misma API.',
    },
    tips: {
      internal: 'Esta página es interna: el equipo de producto la usa para decidir sobre versiones y configuraciones, no el hotel.',
    },
  },
};

export default fit;
